import React from 'react';
import { FormattedMessage } from 'react-intl';

import { getTimestampRelativeFormat } from '@futrli/localisation';

import { SyncControlDatasourceState } from '../types';

interface SyncMessageProps {
  datasourceState: SyncControlDatasourceState;
  dataSyncedMessage?: React.ReactNode;
  syncTimestamp: string;
  errorMessage?: React.ReactNode;
  syncingMessage?: React.ReactNode;
}

export const SyncMessage = ({
  datasourceState,
  dataSyncedMessage,
  syncTimestamp,
  errorMessage,
  syncingMessage
}: SyncMessageProps) => {
  switch (datasourceState) {
    case SyncControlDatasourceState.SYNCING: {
      return (
        <span data-testid="sync-control-in-progress">
          {syncingMessage || <FormattedMessage id="common.syncing" defaultMessage="Syncing" />}
        </span>
      );
    }
    case SyncControlDatasourceState.RECONNECTING: {
      return (
        <span data-testid="sync-control-in-progress">
          <FormattedMessage id="common.reconnecting" defaultMessage="Reconnecting" />
        </span>
      );
    }
    case SyncControlDatasourceState.PENDING_SETUP: {
      return (
        <span data-testid="sync-control-pending-setup">
          <FormattedMessage id="common.pending_setup" defaultMessage="Pending setup" />
        </span>
      );
    }
    case SyncControlDatasourceState.SYNC_FAILED: {
      return (
        <span data-testid="sync-control-failure">
          {errorMessage || (
            <FormattedMessage
              id="predict.last_sync_failure"
              defaultMessage="The last sync we tried was unsuccessful. Please try again. If the issue persists please contact support"
            />
          )}
        </span>
      );
    }
    case SyncControlDatasourceState.NOT_CONNECTED: {
      return (
        <span data-testid="sync-control-not_connected">
          <FormattedMessage
            id="predict.please_reconnect_datasource"
            defaultMessage="Please reconnect your datasource to sync your data."
          />
        </span>
      );
    }
    default: {
      return (
        <React.Fragment>
          {dataSyncedMessage || <FormattedMessage id="import.data_synced" defaultMessage="Data synced" />}
          <span data-testid="sync-control-complete">{'\u00a0'}</span>
          <span style={{ fontWeight: 500 }}>
            {getTimestampRelativeFormat(syncTimestamp, Date.now(), 1, false, { sentenceCase: true })}
          </span>
          <span>{'.'}</span>
        </React.Fragment>
      );
    }
  }
};
